export interface ProductWidgetMapping {
  productCode: string;
  widgetId: string;
}

export function parseProductWidgetMapping(mappingString: string | undefined) {
  if (!mappingString) {
    return [];
  }

  return mappingString
    .split("|")
    .map(pair => pair.trim())
    .filter(pair => pair.length > 0)
    .map(pair => {
      const [productCode, widgetId] = pair.split(":").map(s => s.trim());
      return { productCode, widgetId };
    })
    .filter(mapping => mapping.productCode && mapping.widgetId);
}

declare global {
  interface Window {
    raffleApi?: {
      open?: (id: string) => void;
      close?: (id: string) => void;
      destroy?: (id?: string) => void;
      addEventListener?: (
        event: string,
        callback: (...args: any[]) => void
      ) => void;
    };
  }
}

export {};
